import React, { useState } from 'react';
import styles from './index.module.scss';
import HelpModal from '../../modules/HelpModal';
import { analyticsApi } from '../../../services/analytics';

const Header = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  return (
    <div className={styles.header}>
      <div className={styles.left}>
        <a href="/">
          <img src="/assets/images/logo.svg" alt="" />
        </a>
      </div>
      <div className={styles.right}>
        <a href="" onClick={(e) => {
          e.preventDefault()
          setIsModalOpen(true)
          analyticsApi.logEvent(
            '',
            'Action',
            {},
            'Help Clicked'
          )
        }}>
          Help
        </a>
      </div>
      {isModalOpen && <HelpModal onCancel={() => setIsModalOpen(false)} />}
    </div>
  );
};

export default Header;
